import React from "react";
import { Navigate } from "react-router-dom";

const InventoryStockComponent = React.lazy(
  () => import("../../../../../components/inventory/components/stock/page"),
);
const InventoryMovementsComponent = React.lazy(
  () => import("../../../../../components/inventory/components/movements/page"),
);

export const inventoryRoute = [
  {
    path: "stock",
    element: <InventoryStockComponent />,
  },
  {
    path: "movements",
    element: <InventoryMovementsComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/stockify/inventory/stock" />,
  },
];
